import React, { ReactNode } from 'react';
import { KeyboardTypeOptions } from 'react-native';

import { EDataTestId } from '@webtrader/core/constants/test';

import ValidationError from '@/components/FormValidationError';
import TextInput from '@/components/TextInput';

import { StyledFormField, StyledFormTitle, StyledFormTitleContainer, StyledInputWrapper } from './styled';

interface IDemoCreationFormTextFieldProps {
  icon: ReactNode;
  title: string;
  value: string | undefined;
  validationText: string;
  showValidation: boolean;
  keyboardType?: KeyboardTypeOptions;
  onChange: ((value: string | number | undefined) => void) | undefined;
  testID?: EDataTestId;
}

const DemoCreationFormTextField: FCC<IDemoCreationFormTextFieldProps> = (props) => {
  const { icon, title, value, validationText, showValidation, keyboardType = 'default', onChange, testID } = props;

  return (
    <StyledFormField>
      <StyledFormTitleContainer>
        {icon}
        <StyledFormTitle>{title}</StyledFormTitle>
      </StyledFormTitleContainer>
      <StyledInputWrapper>
        <TextInput
          borderless={false}
          keyboardType={keyboardType}
          value={value}
          onChangeText={onChange}
          testID={testID}
        />
        <ValidationError showValidation={showValidation} message={validationText} />
      </StyledInputWrapper>
    </StyledFormField>
  );
};

export default DemoCreationFormTextField;
